import { render } from "./PdfJsViewer.vue?vue&type=template&id=7097b972&scoped=true"
import script from "./PdfJsViewer.vue?vue&type=script&lang=js"
export * from "./PdfJsViewer.vue?vue&type=script&lang=js"

import "./PdfJsViewer.vue?vue&type=style&index=0&id=7097b972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7097b972"]])

export default __exports__